<div class="dialog confirm-dialog">
  <mat-icon class="dialog__close" aria-hidden="false" aria-label="Close icon" mat-dialog-close>close</mat-icon>
  <div mat-dialog-title>
    <h3 class="help" l10nTranslate>shared.alert</h3>
  </div>
  <div mat-dialog-content>
    <p class="message">{{ message }}</p>
    <div mat-dialog-actions>
      <button mat-flat-button color="primary" (click)="onClose(true)" l10nTranslate>shared.tryAgain</button>
    </div>
  </div>
</div>
